// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ListWithImageBlock_wrapper__iZG9c","main":"ListWithImageBlock_main__ZqyZ8","btnWrap":"ListWithImageBlock_btnWrap__NQUkM"};